import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class PriceSpecificationVehiclesValueObject extends SpecificationVehiclesValueObject {
  constructor({icon, id, name}) {
    super(icon, id, name)
  }
}
